import React from 'react';

const containerStyle = {
    margin: "50px auto auto auto",
    width: "60%",
    minWidth: "300px",
    border: "1px solid black",
    padding: "10px",
    borderRadius: "10px"
}

const h1Style = {
    textAlign: "center",
    textDecoration: "underline"
}

const pStyle = {

}

export default function WarningMessage({message}) {

  return (
    <div style={containerStyle}>
        <h1 style={h1Style}>Communication importante</h1>
        <p style={pStyle}>{message}</p>
    </div>
  );
}